import * as StM from '../../models/store';
import BaseReducer from '../baseReducer';
import * as _ from 'lodash';

export default class CreateNotificationDialogReducer extends BaseReducer {
    static handle(state: StM.ICreateNotificationDialogStoreState = new StM.CreateNotificationDialogStoreState(), action: any): StM.ICreateNotificationDialogStoreState {
        switch (action.type) {
            case 'Dialogs/Admin/CreateNotification/Open': {
                return <StM.ICreateNotificationDialogStoreState>_.assign({}, state, { isOpened: true });
            }
            case 'Dialogs/Admin/CreateNotification/Close': {
                return <StM.ICreateNotificationDialogStoreState>_.assign({}, state, { isOpened: false });
            }
            default: {
                return state;
            }
        }
    }
}
